import { useQuery } from "@apollo/client";
import { useFormikContext } from "formik";
import React, { useContext, useMemo, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { GetOrganization } from "../../Queries";
import { RouteContext } from "../../Routing/Routing";
import {
  GetOrganization as GetOrganizationQuery,
  GetOrganizationVariables,
} from "../../types/GetOrganization";
import Form from "../Form";
import LocationForm from "../LocationForm";
import Loader from "../Loader";

const NewUserComp = (() => {
  const { oid } = useContext(RouteContext)?.routeData;
  const { data, loading } = useQuery<
    GetOrganizationQuery,
    GetOrganizationVariables
  >(GetOrganization, {
    variables: { id: oid },
  });
  const { isValid, dirty, isSubmitting } = useFormikContext<any>();
  const [disable, setDisable] = useState(false);
  const categories = useMemo(() => {
    return [
      {
        label: "(none)",
        value: null as any,
      },
    ].concat(
      data?.organization?.directoryCategories?.map((category) => ({
        label: category.name,
        value: category.id,
      })) ?? []
    );
  }, [data?.organization]);

  return (
    <div>
      {disable ? (
        <div style={{ pointerEvents: "none", opacity: "0.4" }}>
          <Form className="mt-4">
            <Loader loaded={!isSubmitting} />
            <Form.Row>
              <Form.Field
                type="text"
                name="first_name"
                placeholder="First Name"
                column
              />
              <Form.Field
                type="text"
                name="last_name"
                placeholder="Last Name"
                column
              />
            </Form.Row>
            <Form.Row>
              <Form.Select
                name="category"
                placeholder="Category"
                column
                options={categories ?? []}
                isLoading={loading}
              />
            </Form.Row>
            <Form.Row className="mt-3">
              <Form.Field
                type="email"
                name="email"
                placeholder="Contact Email"
                column
              />
              <Form.Field
                type="tel"
                name="phone_number"
                placeholder="Contact Phone"
                column
              />
            </Form.Row>
            <LocationForm name="location" />
            <Row className="mt-4">
              <Col>
                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      disabled={!isValid || !dirty}
                      type="submit"
                      className="mr-1"
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      ) : (
        <div>
          <Form className="mt-4">
            <Loader loaded={!isSubmitting} />
            <Form.Row>
              <Form.Field
                type="text"
                name="first_name"
                placeholder="First Name"
                column
              />
              <Form.Field
                type="text"
                name="last_name"
                placeholder="Last Name"
                column
              />
            </Form.Row>
            <Form.Row>
              <Form.Select
                name="category"
                placeholder="Category"
                column
                options={categories ?? []}
                isLoading={loading}
              />
            </Form.Row>
            <Form.Row className="mt-3">
              <Form.Field
                type="email"
                name="email"
                placeholder="Contact Email"
                column
              />
              <Form.Field
                type="tel"
                name="phone_number"
                placeholder="Contact Phone"
                column
              />
            </Form.Row>
            <LocationForm name="location" />
            <Row className="mt-4">
              <Col>
                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      disabled={!isValid || !dirty}
                      onClick={() => setDisable(true)}
                      type="submit"
                      className="mr-1"
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </div>
  );
}) as React.FC<{}>;

export default NewUserComp;
